// List of fields that need to be validated for number input.
export const numberFields = new Set([
    'cashWithdrawFee',
    'thaiBaht',
    'jpYen',
    'amount',
    'weight',
    'weightPrice',
    'deliveryFeeJp',
    'deliveryFeeTh',
    'productRate',
    'creditRate',
    'downRate',
    'weightRate',
    'codRate',
    'boxNo',
    'cashWithdraw',
    'qty',
    'sevenFee',
    'extraFlowDiscount'
]);

/**
 * Validates the given value and ensures it's a valid number format. 
 * If the value is not a valid number format, it will return the provided fallback value.
 * 
 * @param {string} value - The value to validate.
 * @param {*} fallbackValue - The value to return if the validation fails.
 * @returns {string|*} - The validated value or the fallback value.
 */
export function validateNumberInput(value, fallbackValue) {
    if (value === ".") return fallbackValue;
    return /^[0-9]*\.?[0-9]*$/.test(value) ? value : fallbackValue;
}
